export default "__VITE_ASSET__BUztPHDb__"